export { FolioFisico, QrCargaMensaje } from "./foliofisico";
export { ResumenCargaDescarga } from "./resumen";
export { UltimoEscaneoComponent } from "./ultimoescaneo";
export { GuiasEnCargaDescarga } from "./guiascarga";
export { PendientesCargaDescarga } from "./pendientes";
export { GuiasEnCargaDescargaZE } from "./guiasCargaDescargaZE";


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/index.tsx